import React from "react";

export const HorizontalRow = ({ title, children, testId }) => (
  <section className="mb-10 sm:mb-14" data-testid={testId}>
    <div className="flex items-baseline gap-3 px-4 sm:px-8 mb-4">
      <span className="w-6 h-[3px] bg-blood rounded-full glow-box" />
      <h2 className="text-xl sm:text-2xl font-display font-bold tracking-tight text-white">{title}</h2>
    </div>
    <div className="flex overflow-x-auto gap-4 sm:gap-5 px-4 sm:px-8 pb-4 snap-x snap-mandatory scrollbar-hide">
      {children}
    </div>
  </section>
);
